function TradersITReport() {
    return (
        <div>
            <h2>Traders IT Report</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default TradersITReport;